import { If } from "components";

import { ConfirmApproveModal, RejectModal } from "../../modals";
import { ReturnModalsAtomProps } from "../ReturnsTable.types";

export const ReturnModals = ({
  actionConfirmingIndex,
  setActionConfirmingIndex,
  approveModal,
  rejectModal,
  returnId,
  refetchReturns
}: ReturnModalsAtomProps) => {
  return (
    <If condition={actionConfirmingIndex !== null}>
      <>
        <ConfirmApproveModal
          onClose={() => {
            approveModal.setFalse();
            setActionConfirmingIndex(null);
          }}
          isOpen={approveModal.value}
          returnId={returnId}
          refetchReturns={refetchReturns}
        />

        <RejectModal
          onClose={() => {
            rejectModal.setFalse();
            setActionConfirmingIndex(null);
          }}
          isOpen={rejectModal.value}
          returnId={returnId}
          refetchReturns={refetchReturns}
        />
      </>
    </If>
  );
};
